(function() {
  function initAnnouncementBarSwiper() {
    if (typeof Swiper !== 'undefined') {
      const announcementBarSwiper = document.querySelectorAll('.announcement-bar-swiper');

      announcementBarSwiper.forEach(announcementBarSwiper => {
        const swiperObject = JSON.parse(announcementBarSwiper.querySelector('.swiper-wrapper').dataset.swiperObject);
        new Swiper(announcementBarSwiper, swiperObject);
      });
      return true;
    }
    return false;
  }

  function waitForSwiper() {
    if (!initAnnouncementBarSwiper()) {
      setTimeout(waitForSwiper, 100);
    }
  }

  waitForSwiper();
})();
